module.exports = __webpack_public_path__ + "img/fondo.96574290.png";